module.exports = __webpack_public_path__ + "img/app.8c2b6573.png";